/**
 * Local development only (VITE_AUTH_MODE=local): act as another person to test
 * roles. Sends x-dev-user to the local API. Never rendered in a production build.
 */
import { useState } from "react";
import { LOCAL_AUTH } from "../auth/cognito";
import { devUser, setDevUser } from "../lib/api";

const KNOWN_KEY = "docvault.devKnown";

export function DevPanel() {
  const [min, setMin] = useState(true);
  const [email, setEmail] = useState("");
  if (!LOCAL_AUTH) return null;
  const known: string[] = (() => { try { return JSON.parse(localStorage.getItem(KNOWN_KEY) ?? "[]") as string[]; } catch { return []; } })();
  const current = devUser();
  const actAs = (e: string) => {
    const v = e.trim().toLowerCase();
    if (v) localStorage.setItem(KNOWN_KEY, JSON.stringify([v, ...known.filter((k) => k !== v)].slice(0, 6)));
    setDevUser(v);
    window.location.assign("/");
  };
  return (
    <aside className={`devpanel ${min ? "min" : ""}`}>
      <div className="dh" onClick={() => setMin((m) => !m)}><span>Local dev · act as</span><span>{min ? "▸" : "▾"}</span></div>
      <div className="db">
        <div style={{ color: "var(--muted)" }}>Only in local development. New people start with no access until an admin adds them in Settings &gt; People &amp; roles.</div>
        <button className={!current ? "on" : ""} onClick={() => actAs("")}>Default admin <small>(LOCAL_USER_EMAIL)</small></button>
        {known.map((k) => <button key={k} className={current === k ? "on" : ""} onClick={() => actAs(k)}>{k}</button>)}
        <form onSubmit={(e) => { e.preventDefault(); if (email.trim()) actAs(email); }} style={{ display: "flex", gap: 6 }}>
          <input className="inp" style={{ padding: "5px 8px" }} placeholder="someone@itassurancemsp.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          <button type="submit">Go</button>
        </form>
      </div>
    </aside>
  );
}
